import React, {useEffect, useState} from 'react';
import { TextField, Button, CircularProgress, Grid } from '@material-ui/core'
import { useHistory, useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { axiosWithAuth } from '../utils/axiosWithAuth';
import { ERROR, LOADING, LOADING_OFF } from '../store/actions/UserAction';
import styled from 'styled-components';
import { createMuiTheme, MuiThemeProvider } from '@material-ui/core';
import { lightGreen } from '@material-ui/core/colors';
const greenTheme = createMuiTheme({ palette: { primary: lightGreen } })

const initialEvent = {
    eventname: '',
    description: '',
    date: '',
    location: '',
}

  const Form = styled.form`
  max-width: 100%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  background: white;
  padding: 20% 0;
  margin-top: 7rem;
  margin-bottom: 7rem;
  @media (min-width: ${props => props.theme.mobileBreakpoint}){
      max-width: 80%;
      /* margin-top: 28%; */
      border: 1px grey solid;
      border-radius: 1.4%;
      padding: 2% 0;
  }
  @media (min-width: ${props => props.theme.tabletBreakpoint}){
      border: 1px grey solid;
      /* margin-top: 10%; */
      border-radius: 1.4%;
      max-width: 45%;
  }
`


const StyledTF = styled(TextField)`
  width: 80%;
`

const EditEvent = (props) => {
    const { id } = useParams()
    const [event, setEvent] = useState(initialEvent)
    let history = useHistory()
    let dispatch = useDispatch()

    let roles = useSelector(state => state.userInfo)

    const inputHandler = (e) => {
        e.preventDefault()
        setEvent({...event, [e.target.name]: e.target.value})
    }

    const submitHandler = (e) => {
        e.preventDefault()
        dispatch({type: ERROR, payload: ''})
        if (event.description && event.description.trim().length-1 > 250){
            dispatch({type: ERROR, payload: 'Description cannot contain more than 250 characters'})
            return
        }
        dispatch({type: LOADING, payload: ''})
        const eventDetail = {
            'eventname': event.eventname ? event.eventname : "TBA",
            'description': event.description.trim(),
            'date': event.date ? event.date : "TBA",
            'location': event.location ? event.location : "TBA"
        }
        axiosWithAuth()
            .put(`/events/event/${id}`, eventDetail)
            .then(res => {
                dispatch({type: ERROR, payload: 'SUCCESS'})
            })
            .catch(err => {
                dispatch({type: ERROR, payload: "That wasn't suppose to happen, try again"})
            })
            .finally(()=>{
                dispatch({type: LOADING_OFF, payload: ''})
                history.push('/event/', [roles])
            })
    }

    const cancelHandler = (e) => {
        e.preventDefault()
        setEvent(initialEvent)
        dispatch({type: ERROR, payload: ''})
        history.push('/event')
    }

    const deleteHandler = (e) => {
        e.preventDefault()
        if (!window.confirm("Are you sure you want to delete this event")) {
            return
        }
        dispatch({type: LOADING, payload: ''})
        dispatch({type: ERROR, payload: ''})
        axiosWithAuth()
            .delete(`events/event/${id}`)
            .then(res => {
                history.push('/event')
            })
            .catch(err => {
                dispatch({type: ERROR, payload: "That wasn't suppose to happen, try again"})
            })
            .finally(()=>{
                dispatch({type: LOADING_OFF, payload: ''})
            })
    }


    useEffect(()=> {
        axiosWithAuth()
            .get(`/events/event/${id}`)
            .then(res => {
                setEvent(res.data)
                dispatch({type: ERROR, payload: ''})
            })
            .catch(err => {
                dispatch({type: ERROR, payload: "That wasn't suppose to happen, try again"})
                history.push('/event')
            })
    },[])

    useEffect(() => {
        if (roles && roles.roles[0].role.name === "MEMBER") {
            history.push('/')
        }
    },[roles])

    return (
        <>
            {!event.eventid ? <CircularProgress /> : 
            <>
                <Form onSubmit={submitHandler}>
                <Grid container direction={"column"} spacing={2}>
                    <Grid item>
                        <h4>EDIT EVENT</h4>
                    </Grid>
                    <Grid item>
                        <StyledTF
                            label='Event Name'
                            variant="filled"
                            name='eventname'
                            value={event.eventname}
                            onChange={inputHandler}
                            type='text'
                        />
                    </Grid>
                        <Grid item>
                            <StyledTF
                                multiline
                                label='Description'
                                variant="filled"
                                name='description'
                                value={event.description}
                                onChange={inputHandler}
                                type='text'
                            />
                        </Grid>
                        <Grid item>
                            <StyledTF
                                label='Date'
                                variant="filled"
                                name='date'
                                value={event.date}
                                onChange={inputHandler}
                                type='text'
                            />
                        </Grid>
                    <Grid item>
                        <StyledTF
                            label='Location'
                            variant="filled"
                            value={event.location}
                            name='location'
                            onChange={inputHandler}
                            type='text'
                            />
                    </Grid>
                    <Grid item>
                        <Grid container direction={"row"} spacing={2} justify={"center"}>
                            <MuiThemeProvider theme={greenTheme}>
                                <Grid item>
                                    <Button variant="contained" color="primary" onClick={cancelHandler}>
                                        Cancel
                                    </Button>
                                </Grid>
                                <Grid item>
                                    <Button variant="contained" color="secondary" onClick={deleteHandler}>
                                        Delete
                                    </Button>
                                </Grid>
                                <Grid item>
                                    <Button type='submit' variant="contained" color="primary">
                                        Save
                                    </Button>
                                </Grid>
                            </MuiThemeProvider>
                        </Grid>
                    </Grid>
                    </Grid>
                </Form>
            </>}
        </>
    )
}

export default EditEvent